import { render, staticRenderFns } from "./ResultDetailInvestOutLeft.vue?vue&type=template&id=0d1e9590&scoped=true&"
import script from "./ResultDetailInvestOutLeft.vue?vue&type=script&lang=js&"
export * from "./ResultDetailInvestOutLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1e9590",
  null
  
)

export default component.exports